import FormattedMessage from 'I18n/components/FormattedMessage';
import { Small } from 'foundations-components/transitional/components/Small';
import { useSelector } from 'react-redux';
import { useDisplayedCurrencyCode } from '../../hooks/useCurrencies';
import { useAppSelector } from '../../reducers';
import { getRequiredOnboardingSkuIdsByProductLevelSelector } from '../../selectors/PricingSelectors';
import { getAllRequiredOnboardingSkuIdsFromListSelector, requiredOnboardingChoiceSkuIdsSelector } from '../../selectors/RequiredOnboardingSelectors';
import withErrorBoundary from '../error-boundary/withErrorBoundary';
import RequiredOnboardingSubtext from './RequiredOnboardingSubtext';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const RequiredOnboardingSubtextContainer = ({
  skuIds,
  tab,
  trackingSource,
  includesOnboardingCost = false
}) => {
  const currencyCode = useDisplayedCurrencyCode();
  const onboardingSkuIdsMap = useSelector(state => {
    return getRequiredOnboardingSkuIdsByProductLevelSelector(state, {
      skuIds
    });
  });
  const allRequiredOnboardingSkuIds = useSelector(state => getAllRequiredOnboardingSkuIdsFromListSelector(state, {
    skuIds
  }));
  const hasOnboardingChoices = useAppSelector(state => skuIds.some(skuId => requiredOnboardingChoiceSkuIdsSelector(state, {
    skuId
  })));
  if (hasOnboardingChoices && !includesOnboardingCost) {
    return /*#__PURE__*/_jsx(Small, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "planBuilder.requiredOnboardingSubtext.genericNotIncluded"
      })
    });
  }

  // If there are multiple onboarding products, don't show a price
  if (allRequiredOnboardingSkuIds.length > 1) {
    return /*#__PURE__*/_jsx(Small, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "planBuilder.requiredOnboardingSubtext.genericIncluded"
      })
    });
  }
  return /*#__PURE__*/_jsx(_Fragment, {
    children: Object.keys(onboardingSkuIdsMap).map(langKey => /*#__PURE__*/_jsx(RequiredOnboardingSubtext, {
      skuIds: onboardingSkuIdsMap[langKey],
      currencyCode: currencyCode,
      langKey: langKey,
      tab: tab,
      trackingSource: trackingSource,
      includesOnboardingCost: includesOnboardingCost
    }, langKey))
  });
};
export default withErrorBoundary(RequiredOnboardingSubtextContainer, {
  fallback: null
});